import { APIAsset } from '@mss/mss-component-library';

const sanitizePostKeys = [
  'id',
  'created_at',
  'updated_at',
  'deleted',
  'center_synced_at',
  'site',
  'tempId',
];
const sanitizePutKeys = [...sanitizePostKeys, 'type'];
const sanitizePatchKeys = [...sanitizePutKeys];

export function sanitizeAsset(
  asset: APIAsset<any>,
  keysToRemove: string[],
  removeEmpty?: boolean
) {
  return Object.keys(asset).reduce(
    (acc, key) => {
      if (keysToRemove.includes(key)) return acc;
      if (removeEmpty && asset[key] === '') return acc;
      return { ...acc, [key]: asset[key] };
    },
    {} as Partial<APIAsset<any>>
  );
}

export function sanitizeAssetForPost(asset: APIAsset<any>) {
  return sanitizeAsset(asset, sanitizePostKeys, true);
}

export function sanitizeAssetForPut(asset: APIAsset<any>) {
  return sanitizeAsset(asset, sanitizePutKeys);
}

export function sanitizeAssetForPatch(asset: APIAsset<any>) {
  return sanitizeAsset(asset, sanitizePatchKeys);
}
